module.exports = __webpack_public_path__ + "media/images/payments/ccbill_initial-7100f48ec496f81629df8c9f0a262af6.png";